import PaperCard from "../../components/PaperCard";
import {useContext, useEffect, useState} from "react";
import {getAuth} from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import UserContext from "../../components/UserContext";
import {Link, Navigate, useNavigate} from "react-router-dom";

const NAMES = [
    "The SQ3R Study Technique: A Forgotten Research Target",
    "The SQ3R Study Technique: A Forgotten Research Target",
    "The SQ3R Study Technique: A Forgotten Research Target",
    "The SQ3R Study Technique: A Forgotten Research Target",
    "The SQ3R Study Technique: A Forgotten Research Target",
    "The SQ3R Study Technique: A Forgotten Research Target",
]

function Manager() {
    const [papers, setPapers] = useState({});
    const user = useContext(UserContext);
    const auth = getAuth();
    const navigate = useNavigate();

    if (!user) {
        navigate('/');
    }

    useEffect(
        () => {
            if (!user) {
                return
            }
            const uid = user.uid;

            const db = getFirestore();
            const docRef = doc(db, 'users', uid);

            getDoc(docRef).then(
                (docSnap) => {
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setPapers(data['papers']);
                    }
                }
            );
        },
        [user]
    )
    console.log('p', Object.entries(papers));

    return (
        <section className={""}>
            <div className={"w-full border-b border-gray-200 bg-gray-100"}>
                <nav className={"w-1/2 mx-auto flex  p-4 justify-between align-center"}>
                    <img src = "logo.png" className={"w-10 h-10"}/>
                    <button className={"px-1 py-0.5 active:opacity-40 hover:underline"} onClick={async () => {
                        await auth.signOut();
                        navigate('/')
                    }}>Log out</button>
                </nav>
            </div>
            <div className={"w-1/2 mx-auto mt-20"}>
                <h1 className={"font-bold text-lg"}>My Papers</h1>
                <div className={"mt-10 flex flex-wrap justify-between"}>
                    {
                        Object.entries(papers)
                            .map(
                                (x) => (
                                    <Link
                                        to={'/CardScreen'}
                                        key={x[0]}
                                        state={{
                                            paperName: x[0],
                                            cards: x[1]
                                    }}
                                    >
                                        <PaperCard name={x[0]} />
                                    </Link>
                                )
                            )
                    }

                </div>
            </div>
        </section>
    )
}

export default Manager;